import React, { useState, useEffect } from 'react';
import { API_URL } from './constants';

function ReferralsPage({ onBookNow, onAccountClick, guestInfo }) {
  const [referralCode, setReferralCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [copiedField, setCopiedField] = useState('');

  useEffect(() => {
    if (!guestInfo?.guestId) return;
    setLoading(true);
    fetch(`${API_URL}/api/account/referral-code/${guestInfo.guestId}`)
      .then(r => r.json())
      .then(data => {
        if (data.success && data.referralCode) {
          setReferralCode(data.referralCode);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [guestInfo?.guestId]);

  const invitationLink = referralCode
    ? `https://book.cutiepiewaxbar.com/?ref=${encodeURIComponent(referralCode)}`
    : '';

  function handleCopy(text, field) {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(''), 2000);
    }).catch(() => {});
  }

  return (
    <div className="step-content">
      <h1 className="step-title">REFER A FRIEND & GET REWARDED</h1>
      <p className="step-subtitle">Share the love — you both win</p>

      <div className="referral-rewards">
        <div className="referral-reward-box">
          <div className="referral-reward-amount">$20</div>
          <div className="referral-reward-label">for you</div>
          <div className="referral-reward-detail">Gift card after your friend completes their first service</div>
        </div>
        <div className="referral-reward-box">
          <div className="referral-reward-amount">$10</div>
          <div className="referral-reward-label">for your friend</div>
          <div className="referral-reward-detail">Off their first visit — applied automatically at checkout</div>
        </div>
      </div>

      {/* Referral Code + Invitation Link (signed in only) */}
      {guestInfo && (
        <div className="referral-code-section">
          {loading ? (
            <div className="loading-spinner" style={{ margin: '20px auto' }}></div>
          ) : referralCode ? (
            <>
              <div className="referral-code-row">
                <span className="referral-code-label">Referral Code</span>
                <div className="referral-code-input-group">
                  <input type="text" className="referral-code-input" value={referralCode} readOnly />
                  <button className="referral-copy-btn" onClick={() => handleCopy(referralCode, 'code')}>
                    {copiedField === 'code' ? 'Copied!' : 'Copy'}
                  </button>
                </div>
              </div>
              <div className="referral-code-row">
                <span className="referral-code-label">Invitation Link</span>
                <div className="referral-code-input-group">
                  <input type="text" className="referral-code-input" value={invitationLink} readOnly />
                  <button className="referral-copy-btn" onClick={() => handleCopy(invitationLink, 'link')}>
                    {copiedField === 'link' ? 'Copied!' : 'Copy'}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p className="referral-no-code">Sign in to see your personal referral code</p>
          )}
        </div>
      )}

      <h2 className="referral-section-title">HOW IT WORKS</h2>

      <div className="referral-steps">
        <div className="referral-step">
          <div className="referral-step-number">1</div>
          <div className="referral-step-title">Find Your Code</div>
          <div className="referral-step-desc">Your personal referral code is above — just copy it and share with friends!</div>
        </div>
        <div className="referral-step">
          <div className="referral-step-number">2</div>
          <div className="referral-step-title">Refer a Friend</div>
          <div className="referral-step-desc">Share your code or invitation link when they sign up, or they can mention your name when booking</div>
        </div>
        <div className="referral-step">
          <div className="referral-step-number">3</div>
          <div className="referral-step-title">Earn Rewards</div>
          <div className="referral-step-desc">You get a $20 gift card once your friend completes their first service</div>
        </div>
      </div>

      {!guestInfo && (
        <p className="referral-account-hint">
          Sign in to see your personal referral code and invitation link
        </p>
      )}

      <div className="referral-ctas">
        <button className="auth-button" style={{ width: '100%', maxWidth: '400px' }} onClick={onBookNow}>
          BOOK NOW
        </button>
        {!guestInfo && (
          <button
            className="auth-button"
            style={{ width: '100%', maxWidth: '400px', marginTop: '12px', background: 'transparent', color: '#F78DA7', border: '1.5px solid #F78DA7' }}
            onClick={onAccountClick}
          >
            SIGN IN
          </button>
        )}
      </div>
    </div>
  );
}

export default ReferralsPage;
